<template>
  <nav
    class="navbar navbar-expand-xl sticky-top bg-white d-none d-sm-flex"
    style="z-index: 1030"
  >
    <div class="container-lg">
      <a class="navbar-brand fw-700" @click="$router.push('/home')">
        <img
          class="brand-height"
          v-if="siteLogoImgSmUrl"
          :src="convertVirtualPathToRealPath(baseUrl, siteLogoImgSmUrl)"
          alt="logo"
        />
        <img v-else class="brand-height" alt="尚無Logo" />
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasDarkNavbar"
        aria-controls="offcanvasDarkNavbar"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div
        class="offcanvas offcanvas-end"
        tabindex="-1"
        id="offcanvasDarkNavbar"
        aria-labelledby="offcanvasDarkNavbarLabel"
      >
        <div class="offcanvas-header pb-2">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div class="offcanvas-body align-items-center py-0">
          <ul class="navbar-nav ms-auto mb-2 mb-xl-0">
            <li class="nav-item">
              <button
                class="nav-link"
                :class="{ active: currentRoute === '/news' }"
                @click="$router.push('/news')"
              >最新訊息</button>
            </li>
            <li class="nav-item dropdown">
              <button
                class="nav-link"
                :active="currentRoute === '/course' || currentRoute === '/single-course'"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                課程報名<i class="bi bi-chevron-down ms-2"></i>
              </button>
              <ul class="dropdown-menu">
                <li>
                  <button
                    class="dropdown-item"
                    :class="{ active: currentRoute === '/single-course' }"
                    @click="$router.push('/single-course')"
                  >單堂課程報名</button>
                </li>
                <li>
                  <button
                    class="dropdown-item"
                    :class="{ active: currentRoute === '/course' }"
                    @click="$router.push('/course')"
                  >多堂課程報名</button>
                </li>
              </ul>
            </li>
            <li class="nav-item dropdown">
              <button
                class="nav-link"
                :active="currentRoute === '/venue-booking/generally' ||
                         currentRoute === '/venue-booking/season'"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                場地預約<i class="bi bi-chevron-down ms-2"></i>
              </button>
              <ul class="dropdown-menu">
                <li>
                  <button
                    class="dropdown-item"
                    @click="$router.push('/venue-booking/generally')"
                    :class="{
                      active: currentRoute === '/venue-booking/generally'
                    }"
                  >臨租</button>
                </li>
                <li>
                  <button
                    class="dropdown-item"
                    @click="$router.push('/venue-booking/season')"
                    :class="{
                      active: currentRoute === '/venue-booking/season'
                    }"
                  >季租</button>
                </li>
              </ul>
            </li>
            <li class="nav-item">
              <button
                class="nav-link"
                @click="$router.push('/shop')"
                :class="{
                  active: currentRoute === '/shop'
                }"
              >線上購買</button>
            </li>
            <li class="nav-item">
              <button
                @click="fetchBrandsList()"
                class="nav-link"
              >切換品牌/場館</button>
            </li>
          </ul>
          <div v-if="token" class="dropdown py-2 ms-xl-3">
            <button
              class="nav-link fw-400 cursor-pointer"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="bi bi-person-circle me-1"></i>
              {{ maskName(userRealName) }}
              <i class="bi bi-chevron-down ms-1"></i>
            </button>
            <ul class="dropdown-menu dropdown-menu-xl-end">
              <li>
                <button
                  class="dropdown-item"
                  @click="$router.push(screenWidth >= 576 ? '/member/calendar' : '/member')"
                >會員中心</button>
              </li>
              <li><button class="dropdown-item" @click="logout()">登出</button></li>
            </ul>
          </div>
          <button v-else class="nav-link w-auto fw-400 ms-xl-3" @click="$router.push('/login')">
            <i class="bi bi-person-circle me-1"></i>登入
          </button>
        </div>
      </div>
    </div>
  </nav>
  <Venue
    v-model="brandsDialogVisible"
    :intro="brands"
    :loading="brandsListLoading"
  />
</template>

<script>
import { GetBrandList } from '@/api/brand'
import { getUserRealName, getBrandId, getToken, getSiteLogoImgSm } from '@/utils/auth'
import { ConvertVirtualPathToRealPath } from '@/utils/urlHelper'
import Venue from '@/components/Venue.vue'

export default {
  name: 'Header',
  components: { Venue },
  data() {
    return {
      brandId: getBrandId(),
      isCollapse: false,
      currentRoute: '',
      userRealName: '',
      token: getToken(),
      brands: [],
      brandsListLoading: false,
      screenWidth: 0,
      baseUrl: process.env.VUE_APP_BASE_IMG_API.replace(/\/$/, ''),
      siteLogoImgSmUrl: getSiteLogoImgSm(),
      brandsDialogVisible: false
    }
  },
  watch: {
    $router: {
      handler() {
        const realName = getUserRealName()
        if (realName !== undefined) {
          this.userRealName = realName
        }
        this.token = getToken()
      },
      deep: true,
      immediate: true
    },
    $route(to) {
      this.currentRoute = to.fullPath
    }
  },
  computed: {},
  created() {
    this.updateScreenWidth()
  },
  mounted() {
    this.currentRoute = this.$route.fullPath
    this.onScreenResize()
  },
  methods: {
    maskName(name) {
      if (!name) {
        return name
      }
      const len = name.length
      const isChinese = /[\u4e00-\u9fa5]/.test(name)
      if (isChinese) {
        if (len === 2) {
          return name.charAt(0) + '●'
        } else if (len > 2) {
          return name.charAt(0) + '●'.repeat(len - 2) + name.charAt(len - 1)
        }
      } else if (len <= 2) {
        return name.charAt(0) + '●'
      } else if (len <= 4) {
        return name.charAt(0) + '●'.repeat(len - 1)
      } else {
        return name.substring(0, 2) + '●'.repeat(len - 4) + name.substring(len - 2)
      }
      return name
    },
    convertVirtualPathToRealPath(baseUrl, fileUrl) {
      return ConvertVirtualPathToRealPath(baseUrl, fileUrl)
    },
    onScreenResize() {
      window.addEventListener('resize', () => {
        this.updateScreenWidth()
      })
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push('/home')
      this.userRealName = ''
    },
    async fetchBrandsList() {
      this.brandsDialogVisible = true
      if (this.brands.length !== 0) {
        return
      }
      this.brandsListLoading = true
      await GetBrandList(this.brandId)
        .then((result) => {
          const { data } = result
          this.brands = data
        })
        .catch((error) => {
          console.error('Error fetching brands list:', error)
        })
        .finally(() => {
          this.brandsListLoading = false
        })
    }
  }
}
</script>

<style>
.navbar-brands-list:first-child hr {
  display: none;
}

a.sites-link {
  color: #1a1a1a;
}

a.sites-link:hover {
  color: #0367fc;
}

.nav-link[active="true"] {
  color: var(--bs-primary-600) !important;
}

ul.dropdown-menu li:first-child .dropdown-item {
  border-top-left-radius: var(--bs-dropdown-border-radius);
  border-top-right-radius: var(--bs-dropdown-border-radius);
}

ul.dropdown-menu li:last-child .dropdown-item {
  border-bottom-right-radius: var(--bs-dropdown-border-radius);
  border-bottom-left-radius: var(--bs-dropdown-border-radius);
}
</style>